import React from "react";
import { Route, Routes } from "react-router-dom";
import { CartProductList } from "./containers";


export const CartProduct = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<CartProductList/>} />
      </Routes>
    </>
  );
};
